import * as React from "react";
import { cx, initials } from "../util.js";

export interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Name used to derive initials and the aria-label. */
  name?: string;
  /** Optional image URL. */
  src?: string;
  /** Size. @default "md" */
  size?: "sm" | "md" | "lg";
  /** Background color (defaults to the accent). */
  color?: string;
  /** Text on a custom background; defaults to white. Accent avatars follow the theme. */
  foregroundColor?: string;
}
/** Circular avatar with image or derived initials. */
export function Avatar({ name = "", src, size = "md", color, foregroundColor, className, style, ...rest }: AvatarProps) {
  return (
    <span
      className={cx("ip-avatar", className)}
      data-size={size}
      style={{ background: color, color: foregroundColor ?? (color ? "#fff" : undefined), ...style }}
      aria-label={name || undefined}
      role={name ? "img" : undefined}
      {...rest}
    >
      {src ? <img src={src} alt={name} /> : initials(name)}
    </span>
  );
}
